import { Link } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useI18n } from "@/i18n/i18n-context";

export default function NotFound() {
  const { t } = useI18n();

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-gray-50">
      <Card className="mx-4 w-full max-w-md">
        <CardContent className="pt-6">
          <div className="mb-4 flex items-center gap-3">
            <AlertCircle className="h-8 w-8 text-rose-500" />
            <h1 className="text-2xl font-bold text-gray-900">
              {t("notFound.title")}
            </h1>
          </div>

          <p className="mt-2 text-sm text-gray-600">{t("notFound.sub")}</p>

          <div className="mt-6">
            <Button asChild variant="outline" className="gap-2">
              <Link href="/">
                <ArrowLeft className="h-4 w-4" /> {t("notFound.backHome")}
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
